import amplitude from 'amplitude-js';
import { AMPLITUDE_KEY } from '../core/constants';

export const initAmplitude = (userId: string | undefined, callback: (key: string) => void) => {
  amplitude.getInstance().init(AMPLITUDE_KEY, userId, {}, () => callback('amplitude'));
};

export const setAmplitudeUserId = (userId: string) => amplitude.getInstance().setUserId(userId);

export const sendAmplitudeData = (eventType: string, eventParams: any) => {
  const params = { ...eventParams } as Record<string, unknown>;
  delete params.stripe_account_name;
  const checkInit = setInterval(() => {
    if (window.sessionStorage.getItem('amplitudeInit') === 'true') {
      amplitude.getInstance().logEvent(eventType, params);
      clearInterval(checkInit);
    }
  }, 500);
};

export const setAmplitudeUserProperties = (properties: object) =>
  amplitude.getInstance().setUserProperties(properties);
